/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
  whenHasPermission,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { ContactDetailsFinanceCompany } from '../../resources/model/contact-details-fincance-company.model';
import { ContactDetailsFinanceCompanyCommonFormState } from '../contact-details-finance-company-common-tab/contact-details-finance-company-common-form.service';
import {
  ContactDetailsSharedCommunicationListFormState,
  ContactDetailsSharedCommunicationListFormStateFactory,
} from '../contact-details-shared-communication-list-tab/contact-details-shared-communication-list-form.service';
import {
  ContactDetailsSharedCustomFieldsFormState,
  ContactDetailsSharedCustomFieldsFormStateFactory,
} from '../contact-details-shared-custom-fields-tab/contact-details-shared-custom-fields-form.service';

import {
  ContactDetailsSharedTermsPayerFormState,
  ContactDetailsSharedTermsPayerFormStateFactory,
} from '../contact-details-shared-terms-tab/contact-details-shared-terms-payer-form.service';

@Injectable()
export class ContactDetailsFinanceCompanyFormState extends FormState<ContactDetailsFinanceCompany> {
  customFieldsForm: ContactDetailsSharedCustomFieldsFormState;
  termsForm: ContactDetailsSharedTermsPayerFormState;
  communicationForm: ContactDetailsSharedCommunicationListFormState;

  constructor(schemaFactory: BuilderFormSchemaFactory,
              private commonForm: ContactDetailsFinanceCompanyCommonFormState,
              customFieldsFormFactory: ContactDetailsSharedCustomFieldsFormStateFactory,
              termsFormFactory: ContactDetailsSharedTermsPayerFormStateFactory,
              communicationFormFactory: ContactDetailsSharedCommunicationListFormStateFactory) {
    super(schemaFactory);

    this.customFieldsForm = customFieldsFormFactory.create();
    this.termsForm = termsFormFactory.create();
    this.communicationForm = communicationFormFactory.create();
  }

  build(financeCompany: ContactDetailsFinanceCompany): void {
    this.commonForm.build(financeCompany.common);
    this.termsForm.build(financeCompany.terms);
    this.communicationForm.build(financeCompany.communication);
    this.customFieldsForm.build(financeCompany.customFields);

    this.initSchema(financeCompany);
    this.setChildForm('common', this.commonForm);
    this.setChildForm('terms', this.termsForm);
    this.setChildForm('communication', this.communicationForm);
    this.setChildForm('customFields', this.customFieldsForm);
  }

  protected buildSchema(_: ContactDetailsFinanceCompany, { root, native }: FormStateSchema): FormRootSchema {
    return root({
      enabled: whenHasPermission(BuilderPermission.Contacts.FinanceCompany.CREATE_EDIT),
      children: {
        common: native(this.commonForm.group),
        terms: native(this.termsForm.group),
        customFields: native(this.customFieldsForm.group),
        communication: native(this.communicationForm.group),
      },
    });
  }
}
